import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../utils/apiRequest";

// Add to Wishlist
export const addToWishlist = createAsyncThunk(
  "user/addToWishlist",
  async (body, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiRequest.addToWishList({ body });
      dispatch(getWishlistItems());
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to add to wishlist"
      );
    }
  }
);

export const getHomeData = createAsyncThunk(
  "user/getHomeData",
  async (body, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiRequest.getHomeData();
 
      return response.data?.data;

    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to load data"
      );
    }
  }
);

// Add to Cart
export const addToCart = createAsyncThunk(
  "user/addToCart",
  async (body, { dispatch, rejectWithValue }) => {
    try {
      
      const response = await apiRequest.addToCart({ body });
      dispatch(getCartItems());
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to add to cart"
      );
    }
  }
);

// Remove from Wishlist
export const removeFromWishlist = createAsyncThunk(
  "user/removeFromWishlist",
  async (body, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiRequest.removeFromWishlist({ id: body });
      dispatch(getWishlistItems());
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to remove from wishlist"
      );
    }
  }
);

// Get Wishlist Items
export const getWishlistItems = createAsyncThunk(
  "user/getWishlistItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.getWishlistItems();
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch wishlist items"
      );
    }
  }
);

// Remove from Cart
export const removeFromCart = createAsyncThunk(
  "user/removeFromCart",
  async (body, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiRequest.removeFromCart({ id: body });
      dispatch(getCartItems());
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to remove from cart"
      );
    }
  }
);

// Get Cart Items
export const getCartItems = createAsyncThunk(
  "user/getCartItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.getCartItems();
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch cart items"
      );
    }
  }
);
